import styled from "@emotion/styled"
import theme from "../../particles/Theme"

const StyledMCRow = styled.div`
  padding: 5rem 0;
  text-align: center;
  background: #efefec;

  a {
    color: ${theme.colors.primary};

    &:hover {
      color: ${theme.colors.primaryHover};
    }
  }

  section {
    display: grid;
    grid-gap: 3rem;
    ${(props: StyledProps) => (props.image ? `max-height: 120px` : null)};

    @media (max-width: ${theme.breakpoints[1]}) {
      display: block;
      max-height: unset;
    }
    article {
      div {
        height: 125px;
        margin-top: 2rem;
      }

      p:not(.no-line) {
        position: relative;
        margin-top: 6rem;
      }
      p:not(.no-line):before {
        content: "";
        position: absolute;
        top: -3rem;
        left: calc(50% - 3.8rem);
        width: 60px;
        height: 8px;
        background: ${(props: StyledProps) =>
          props.image ? `transparent` : `#f15e2d`};
      }
    }
  }
`

type StyledProps = {
  image?
}

export default StyledMCRow
